import { DefaultPage } from './';

export default {
  path: 'tutorial',
  name: 'Tutorial',
  childRoutes: [
    { path: 'default-page', name: 'Default page', component: DefaultPage, isIndex: true },
  ],
};
